import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { environment } from '../../../environments/environment';
import Chart from 'chart.js';

function buildYearOptions() {
  const now = new JstDate();
  const opts = [];
  for (let y = 2015; y <= now.getFullYear() + 1; y++) {
    opts.push({ id: y, name: `${y}年` });
  }
  return opts;
}

const MONTH_KEYS = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec','total'] as const;
const MONTH_LABELS = ['01月','02月','03月','04月','05月','06月','07月','08月','09月','10月','11月','12月'];

const COLOR_PATTERN = [
  '#4ebcc4','#D6FF58','#64F9C1','#5BFF7F','#9fffff','#afffff','#bfffff','#cfffff','#dfffff',
];

function membershipTotalInit(): any {
  const obj: any = { name: '合計' };
  MONTH_KEYS.forEach(k => { obj[k] = 0; });
  return obj;
}

function getMembershipData(data: any[]): any[] {
  const arrays: any[][] = [];
  for (let i = 0; i < 3; i++) {
    const typeData: any[] = JSON.parse(JSON.stringify(data.filter((v: any) => v.type === i)));
    const total: any = membershipTotalInit();
    MONTH_KEYS.forEach(key => { total[key] = typeData.reduce((p: number, v: any) => p + (v[key] || 0), 0); });
    typeData.unshift(JSON.parse(JSON.stringify(total)));
    arrays.push(typeData);
  }

  const [enableData, , disableData] = arrays;
  const changeData: any = membershipTotalInit();
  let lastVal: number | null = null;
  MONTH_KEYS.forEach(key => {
    if (lastVal === null) {
      changeData[key] = '-';
    } else if (key === 'total') {
      changeData[key] = enableData[0]['dec'] - enableData[0]['jan'];
    } else {
      changeData[key] = enableData[0][key] - lastVal;
    }
    lastVal = enableData[0][key];
  });

  const keysWithName = [...MONTH_KEYS, 'name'] as const;
  const disableRate: any[] = enableData.map((enable: any, idx: number) => {
    const json: any = {};
    keysWithName.forEach(key => {
      if (key === 'name') { json.name = enable.name; return; }
      const ec = enable[key] || 0, dc = disableData[idx]?.[key] || 0;
      json[key] = (ec * dc !== 0) ? Math.round(dc / ec * 100 * 100) / 100 : 0;
    });
    return json;
  });

  return [arrays[0], [changeData], arrays[1], arrays[2], disableRate];
}

const SECTION_LABELS = ['会員数', '会員増減', '新規入会', '退会', '参考指標'];

@Component({
    selector: 'app-aggregation-membership',
    imports: [FormsModule, DecimalPipe],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧</span>
    </div>
    <div class="card-body">
      <form novalidate name="myForm">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">店舗</label>
                <div class="border" style="border-color: #c2cfd6 !important; max-height: 8rem; overflow-y: auto;">
                  <table class="table table-sm mt-1 mb-1">
                    @for (s of studios; track s.id; let i = $index) {
                      <tr>
                        <td class="border-0">
                          <div class="custom-control custom-checkbox custom-control-inline">
                            <input class="custom-control-input" type="checkbox" [id]="'check_' + i" [name]="'check_' + i" [value]="s.id"
                              [checked]="studioChecked[s.id]" (change)="onCheckChange(s.id, $any($event.target).checked, $any($event.target))" [disabled]="!isDlButtonActive">
                            <label class="custom-control-label" [for]="'check_' + i">{{ s.name }}</label>
                          </div>
                        </td>
                      </tr>
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">対象年</label>
                <select class="form-control" id="year_pay" name="year_pay"
                  [(ngModel)]="selectedYear" (ngModelChange)="load()" [disabled]="!isDlButtonActive">
                  @for (opt of yearOptions; track opt.id) {
                    <option [ngValue]="opt.id">{{ opt.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          @if (checkLength) {
            <button class="btn btn-success" type="button" (click)="downloadMembershipData()" [disabled]="!isDlButtonActive">
              <i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード
            </button>
          }
        </div>
      </div>
      <form name="membershipForm" method="POST" action="/" style="display: none;">
        <input type="text" name="membership">
        <input type="text" name="selectYear">
        <input type="text" name="selectStudioName">
      </form>
      @if (searching) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (checkLength && !searching && membershipItems.length === 0) {
        <span>該当するデータはありません</span>
      }

      @for (studioData of membershipItems; track studio_i; let studio_i = $index) {
        <div [class.pt-5]="studio_i > 0">
          <div class="mb-4 canvas-container" style="height: 300px;">
            <canvas [id]="'membershipChart' + studio_i"></canvas>
          </div>
          <div class="table-responsive">
            <table style="min-width: 1280px;" class="form-group mb-5 table table-sm table-responsive-sm table-borderless table-ptb-0 horizontal-sticky-table">
              <thead>
                <tr class="table-secondary border-bottom border-light">
                  <td class="pt-0 pb-0" width="10%"></td>
                  <td class="pt-0 pb-0" width="15%"><small>コース</small></td>
                  <td class="pt-0 pb-0 text-right"><small>01月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>02月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>03月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>04月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>05月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>06月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>07月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>08月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>09月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>10月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>11月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>12月</small></td>
                  <td class="pt-0 pb-0 text-right"><small>通期</small></td>
                </tr>
              </thead>
              <tbody>
                @for (section of studioData; track sec_i; let sec_i = $index) {
                  @for (item of section; track row_i; let row_i = $index) {
                    <tr class="border-bottom border-light">
                      @if (row_i === 0) {
                        <td [class.table-primary]="row_i === 0">{{ sectionLabels[sec_i] }}</td>
                        <td [class.table-primary]="row_i === 0">
                          @if (sec_i === 4) { <span>全退会率（退会/会員）</span> }
                        </td>
                      } @else {
                        <td class="table-white"></td>
                        <td class="table-white">{{ item.name }}</td>
                      }
                      <!-- 01月 -->
                      <td class="text-right" [class.table-primary]="row_i === 0">
                        @if (sec_i === 1 && row_i === 0) { <span>-</span> }
                        @else if (sec_i === 4) { <span>{{ item.jan | number:'1.2-2' }}</span> }
                        @else { <span>{{ item.jan | number }}</span> }
                      </td>
                      @for (mk of monthKeysMid; track mk) {
                        <td class="text-right" [class.table-primary]="row_i === 0">
                          @if (sec_i === 4) { <span>{{ item[mk] | number:'1.2-2' }}</span> }
                          @else { <span>{{ item[mk] | number }}</span> }
                        </td>
                      }
                      <!-- 通期 -->
                      <td class="text-right" [class.table-primary]="row_i === 0">
                        @if (sec_i === 4 || sec_i === 0) { <span>-</span> }
                        @else { <span>{{ item.total | number }}</span> }
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      @for (_ of emptySlotIndexes; track $index) {
        <div class="pt-5"></div>
      }
    </div>
  </div>
</div>
  `
})
export class AggregationMembershipComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);

  studios: any[] = [];
  studioChecked: Record<number, boolean> = {};
  selectedYear: number = new JstDate().getFullYear();
  membershipItems: any[][][] = [];
  searching = false;
  isDlButtonActive = true;
  private rawDataPerStudio: any[][] = [];
  private charts: any[] = [];
  private selectedIds: number[] = [];
  private loadedStudioIds: number[] = [];

  readonly yearOptions = buildYearOptions();
  readonly sectionLabels = SECTION_LABELS;
  readonly monthKeysMid = ['feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'] as const;

  get checkLength(): boolean {
    return Object.values(this.studioChecked).some(v => v);
  }

  get emptySlotIndexes(): number[] {
    // The legacy template always had three wrappers, but only the second and
    // third wrappers carried pt-5 when no studio was selected.
    return Array.from({
      length: Math.max(0, 3 - Math.max(1, this.membershipItems.length)),
    });
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('データ集計', 's-icon-marketing');
    this.studios = await this.studioService.list('all') ?? [];
    const checked: Record<number, boolean> = {};
    this.studios.forEach((s: any) => { checked[s.id] = false; });
    this.studioChecked = checked;
    if (this.studios.length === 1) {
      this.studioChecked = { ...this.studioChecked, [this.studios[0].id]: true };
      await this.load();
    }
  }

  onCheckChange(studioId: number, checked: boolean, input?: HTMLInputElement): void {
    const newChecked = { ...this.studioChecked, [studioId]: checked };
    const count = Object.values(newChecked).filter(v => v).length;
    if (count > 3) {
      // Reset the native checkbox too: its bound value was already false.
      if (input) input.checked = false;
      this.studioChecked = {};
      this.load();
      return;
    }
    this.studioChecked = newChecked;
    this.load();
  }

  async load(): Promise<void> {
    this.selectedIds = Object.entries(this.studioChecked)
      .filter(([, v]) => v).map(([k]) => +k);
    if (this.selectedIds.length === 0) {
      this.membershipItems = [];
      this.rawDataPerStudio = [];
      this.loadedStudioIds = [];
      this.destroyCharts();
      return;
    }
    this.isDlButtonActive = false;
    this.searching = true;
    this.destroyCharts();
    this.membershipItems = [];
    this.rawDataPerStudio = [];
    this.loadedStudioIds = [];
    try {
      for (const id of this.selectedIds) {
        const raw: any = await this.studioService.getAggregationMembership(id, this.selectedYear) ?? [];
        if (!Array.isArray(raw) || raw.length === 0) continue;
        const studioData: any[] = Array.isArray(raw[0]) ? raw[0] : (raw as any[]);
        this.loadedStudioIds.push(id);
        this.rawDataPerStudio.push(studioData);
        this.membershipItems.push(getMembershipData(studioData));
      }
      setTimeout(() => {
        this.membershipItems.forEach((_, i) => this.renderChart(i));
      }, 0);
    } finally {
      this.searching = false;
      this.isDlButtonActive = true;
    }
  }

  downloadMembershipData(): void {
    if (!this.checkLength || this.rawDataPerStudio.length === 0) return;
    this.isDlButtonActive = false;
    const membership = this.membershipItems.map((_, i) =>
      getMembershipData(this.rawDataPerStudio[i])
    );
    const selectedStudios = this.loadedStudioIds.map(id => this.studios.find((s: any) => s.id === id));
    const form = document.forms.namedItem('membershipForm') as HTMLFormElement | null;
    if (!form) return;
    form.method = 'POST';
    form.action = `${environment.apiBaseUrl}/aggregation/excel/membership`;
    const addField = (name: string, value: string) => {
      (form.elements.namedItem(name) as HTMLInputElement).value = value;
    };
    (form.elements.namedItem('membership') as HTMLInputElement).value = JSON.stringify(membership);
    addField('selectYear', `${this.selectedYear}年`);
    (form.elements.namedItem('selectStudioName') as HTMLInputElement).value = JSON.stringify(selectedStudios);
    form.submit();
    setTimeout(() => { this.isDlButtonActive = true; }, 5000);
  }

  private destroyCharts(): void {
    this.charts.forEach(c => { if (c) c.destroy(); });
    this.charts = [];
  }

  private renderChart(idx: number): void {
    const studioData = this.rawDataPerStudio[idx];
    const membershipData = this.membershipItems[idx];
    if (!studioData || !membershipData) return;

    const studio = this.studios.find((s: any) => s.id === this.loadedStudioIds[idx]);
    const studioName = studio?.name ?? '';

    const enableData = membershipData[0];
    const disableRate = membershipData[4];

    const labels = MONTH_LABELS;
    const lineData: number[] = [];
    const monthKeysOnly = MONTH_KEYS.filter(k => k !== 'total');
    monthKeysOnly.forEach(key => lineData.push(disableRate[0]?.[key] ?? 0));

    const datasets: any[] = [{
      yAxisID: 'y-l-axis-0',
      label: '全退会率（退会/会員）',
      type: 'line',
      tension: 0,
      fill: false,
      borderWidth: 5,
      borderColor: 'rgba(255,240,0,0.8)',
      backgroundColor: 'rgba(255,240,0,0.8)',
      data: lineData,
    }];

    enableData.forEach((row: any, index: number) => {
      if (index === 0) return;
      const barData: number[] = [];
      monthKeysOnly.forEach(key => barData.push(row[key] ?? 0));
      datasets.push({
        yAxisID: 'y-axis-0',
        label: studioName ? `${studioName} : ${row.name}` : row.name,
        borderWidth: 1,
        backgroundColor: COLOR_PATTERN[(index - 1) % COLOR_PATTERN.length],
        data: barData,
        stack: '0',
        barPercentage: 0.8,
      });
    });

    if (this.charts[idx]) { this.charts[idx].destroy(); }
    const ctx = (document.getElementById(`membershipChart${idx}`) as HTMLCanvasElement)?.getContext('2d');
    if (!ctx) return;
    ctx.canvas.height = 300;

    this.charts[idx] = new Chart(ctx, {
      type: 'bar',
      data: { labels, datasets },
      options: {
        title: { display: true, text: `会員推移 : ${studioName}`, padding: 3 },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [
            {
              id: 'y-axis-0',
              position: 'right',
              stacked: true,
              ticks: {
                max: 2000,
                min: 0,
                callback: (label: any) => label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '人',
              },
            },
            {
              id: 'y-l-axis-0',
              type: 'linear',
              position: 'left',
              ticks: {
                max: 30,
                min: 0,
                stepSize: 1,
                callback: (label: any) => label.toString() + '.00%',
              },
              gridLines: { drawOnChartArea: false },
            },
          ],
        },
        legend: { labels: { boxWidth: 30, padding: 20 }, display: true },
        tooltips: { mode: 'label' },
        responsive: true,
        maintainAspectRatio: false,
      },
    } as any);
  }
}
